// src/services/crcNamesService.js
//
// Reads and writes the site's CRC names list (crcNames.js): full names on
// studies linked to coordinators. Its own collection (crc_names); the
// coordinator list and the studies are never written from here. Site staff
// read it; admins add, change and remove links (firestore.rules).

import { collection, deleteDoc, doc, getDocs, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getCrcNamesPath } from "./firestorePaths";

/** Every link at this site. */
export const loadCrcNames = async () =>
  (await getDocs(collection(db, getCrcNamesPath()))).docs.map((d) => ({ id: d.id, ...d.data() }));

/** Save a link (from validateLink) as the signed-in admin. */
export const saveCrcName = async (link, user) =>
  setDoc(doc(db, getCrcNamesPath(), link.id), {
    fullName: link.fullName,
    coordinator: link.coordinator,
    sameAsCoordinator: !!link.sameAsCoordinator,
    updatedBy: String((user && user.email) || ""),
    updatedAt: serverTimestamp(),
  });

/** Remove a link (the studies keep their names; they just stop pointing to that coordinator). */
export const removeCrcName = async (id) => deleteDoc(doc(db, getCrcNamesPath(), id));
